// Entry-point-based side effects for modal close.
// Receives the full Redux state for maximum flexibility.
// Extend the switch cases to add per-entry-point or per-resultPageKey behavior.
const getTdSelectDayUrl = (redirectUrl) => {
    const bookTestDriveIndex = redirectUrl?.indexOf("book-test-drive/");
    if (bookTestDriveIndex === -1 || !redirectUrl) return null;
    return `${redirectUrl.substring(0, bookTestDriveIndex)  }book-test-drive/select-day`;
};

export const runCloseSideEffect = (state) => {
    const { preApprovalOnFly: { entryPoint, resultPageKey, modalConfig } = {} } = state;

    switch (entryPoint) {
    case "pre-approval-landing-screen-revamp":
    case "pre-approval-intro-screen-revamp":
    case "pre-approval-resume-screen":
        if (resultPageKey) {
            window.location.assign("/cars24-finance");
        }
        break;
    case "pre-approval-edit-redirect":
        window.location.assign("/cars24-finance");
        break;
    case "next-steps-non-pre-approved-modal":
    case "booking-confirmed": {
        if (resultPageKey) {
            const selectDayUrl = getTdSelectDayUrl(modalConfig?.redirectUrl);
            if (selectDayUrl) {
                window.location.assign(selectDayUrl);
            }
        }
        break;
    }
    default:
        break;
    }
};
